import { DENOMINATION_TYPES } from '@/modules/proposalRequest/contants/proposalRequest';

const source = process.env.REACT_APP_FILE_STORAGE;
const prefixSource = process.env.REACT_APP_PREFIX_FILE_STORAGE || '';

const sourcePath = `${source}/${prefixSource}`;

export const getFromSource = image => {
  if (!image || typeof image !== 'string') return '';
  const isLocalImage = image.startsWith('/images') || image.startsWith('images/') || image.startsWith('data:');
  const isSocialOrCDNAvatar =
    (image && image.startsWith('http')) || (image && image.startsWith('https'));
  return isSocialOrCDNAvatar || isLocalImage ? image : `${sourcePath}/${image}`;
};

export const getFileNameFromSource = (value, defaultValue) => {
  try {
    if (!value) return defaultValue || '----';
    value = value?.replace(DENOMINATION_TYPES.SURL, '');
    value = value?.replace(DENOMINATION_TYPES.SRL, '');
    const elements = value?.split('.');
    const name = elements[elements?.length - 2];
    const extension = elements?.pop();
    return `${name} ${extension}`;
  } catch (e) {
    return defaultValue || '----';
  }
};
